/* innovio Playful v1 — progressive enhancement. Shopify forms remain functional without JS. */
(function () {
  'use strict';
  function initNavigation() {
    var header = document.querySelector('[data-site-header]');
    if (!header) return;
    var toggle = header.querySelector('[data-nav-toggle]');
    var nav = header.querySelector('[data-nav]');
    if (!toggle || !nav) return;
    function setOpen(open) {
      header.classList.toggle('site-header--open', open);
      toggle.setAttribute('aria-expanded', String(open));
      toggle.setAttribute('aria-label', open ? 'Close navigation' : 'Open navigation');
    }
    toggle.addEventListener('click', function () {
      setOpen(toggle.getAttribute('aria-expanded') !== 'true');
    });
    nav.addEventListener('click', function (event) {
      if (event.target.closest('a')) setOpen(false);
    });
    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && header.classList.contains('site-header--open')) {
        setOpen(false);
        toggle.focus();
      }
    });
    document.addEventListener('click', function (event) {
      if (!header.contains(event.target)) setOpen(false);
    });
  }
  function initQuotes(carousel) {
    if (carousel.dataset.quoteInitialized === 'true') return;
    carousel.dataset.quoteInitialized = 'true';
    var slides = Array.prototype.slice.call(carousel.querySelectorAll('[data-quote-slide]'));
    var dots = Array.prototype.slice.call(carousel.querySelectorAll('[data-quote-dot]'));
    if (slides.length < 2) return;
    var palette = ['var(--red)', 'var(--orange)', 'var(--green)', 'var(--blue)', 'var(--lavender)'];
    var index = 0, timer = null;
    var reducedMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    function show(next, focusDot) {
      index = ((next % slides.length) + slides.length) % slides.length;
      slides.forEach(function (slide, i) { slide.hidden = i !== index; });
      dots.forEach(function (dot, i) { dot.setAttribute('aria-current', String(i === index)); });
      carousel.style.setProperty('--quote-accent', palette[index % palette.length]);
      if (focusDot && dots[index]) dots[index].focus();
    }
    function pause() { if (timer) { window.clearInterval(timer); timer = null; } }
    function play() { if (reducedMotion || timer || document.hidden) return; timer = window.setInterval(function () { show(index + 1, false); }, 7000); }
    var prev = carousel.querySelector('[data-quote-prev]');
    var next = carousel.querySelector('[data-quote-next]');
    if (prev) prev.addEventListener('click', function () { show(index - 1, false); pause(); });
    if (next) next.addEventListener('click', function () { show(index + 1, false); pause(); });
    dots.forEach(function (dot, i) { dot.addEventListener('click', function () { show(i, false); pause(); }); });
    carousel.addEventListener('mouseenter', pause);
    carousel.addEventListener('mouseleave', play);
    carousel.addEventListener('focusin', pause);
    carousel.addEventListener('focusout', function (event) { if (!carousel.contains(event.relatedTarget)) play(); });
    document.addEventListener('visibilitychange', function () { if (document.hidden) pause(); else play(); });
    show(0, false); play();
  }
  function initSimpleCarousel(root, prefix, interval) {
    if (root.dataset.carouselInitialized === 'true') return;
    root.dataset.carouselInitialized = 'true';
    var slides = Array.prototype.slice.call(root.querySelectorAll('[data-' + prefix + '-slide]'));
    var dots = Array.prototype.slice.call(root.querySelectorAll('[data-' + prefix + '-dot]'));
    if (slides.length < 2) return;
    var current = 0, timer = null;
    var reducedMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var count = root.querySelector('[data-' + prefix + '-count]');
    function show(next) {
      current = (next + slides.length) % slides.length;
      slides.forEach(function (slide, i) { slide.hidden = i !== current; });
      dots.forEach(function (dot, i) { dot.setAttribute('aria-current', String(current === i)); });
      if (count) count.textContent = String(current + 1).padStart(2, '0') + ' / ' + String(slides.length).padStart(2, '0');
    }
    function pause() { if (timer) { window.clearInterval(timer); timer = null; } }
    function play() { if (reducedMotion || timer || document.hidden || !interval) return; timer = window.setInterval(function () { show(current + 1); }, interval); }
    var prev = root.querySelector('[data-' + prefix + '-prev]');
    var next = root.querySelector('[data-' + prefix + '-next]');
    if (prev) prev.addEventListener('click', function () { pause(); show(current - 1); });
    if (next) next.addEventListener('click', function () { pause(); show(current + 1); });
    dots.forEach(function (dot, i) { dot.addEventListener('click', function () { pause(); show(i); }); });
    // On touch screens, allow a horizontal swipe without hijacking vertical page scrolling.
    var touchX = null, touchY = null;
    root.addEventListener('touchstart', function (event) {
      if (event.touches.length !== 1) return;
      touchX = event.touches[0].clientX; touchY = event.touches[0].clientY;
    }, { passive: true });
    root.addEventListener('touchend', function (event) {
      if (touchX === null || !event.changedTouches.length) return;
      var deltaX = event.changedTouches[0].clientX - touchX;
      var deltaY = event.changedTouches[0].clientY - touchY;
      touchX = null; touchY = null;
      if (Math.abs(deltaX) > 55 && Math.abs(deltaX) > Math.abs(deltaY) * 1.3) { pause(); show(current + (deltaX < 0 ? 1 : -1)); }
    }, { passive: true });
    root.addEventListener('mouseenter', pause);
    root.addEventListener('mouseleave', play);
    root.addEventListener('focusin', pause);
    root.addEventListener('focusout', function (event) { if (!root.contains(event.relatedTarget)) play(); });
    document.addEventListener('visibilitychange', function () { if (document.hidden) pause(); else play(); });
    show(0); play();
  }
  function initProductMedia(scope) {
    var main = scope.querySelector('[data-product-main-media] img');
    if (!main) return;
    scope.querySelectorAll('[data-product-thumb]').forEach(function (button) {
      button.addEventListener('click', function () {
        if (!button.dataset.imageSrc) return;
        main.src = button.dataset.imageSrc;
        main.removeAttribute('srcset');
        main.alt = button.dataset.imageAlt || main.alt;
        scope.querySelectorAll('[data-product-thumb]').forEach(function (thumb) {
          thumb.removeAttribute('aria-current');
        });
        button.setAttribute('aria-current', 'true');
      });
    });
    var select = scope.querySelector('[data-product-variant-select]');
    var price = scope.querySelector('[data-product-price]');
    if (select && price) select.addEventListener('change', function () {
      var chosen = select.options[select.selectedIndex];
      if (chosen && chosen.dataset.price) price.textContent = chosen.dataset.price;
    });
  }
  function init(scope) {
    initNavigation();
    scope.querySelectorAll('[data-quote-carousel]').forEach(initQuotes);
    scope.querySelectorAll('[data-store-carousel]').forEach(function (element) { initSimpleCarousel(element, 'store', 6000); });
    scope.querySelectorAll('[data-education-carousel]').forEach(function (element) { initSimpleCarousel(element, 'education', 0); });
    scope.querySelectorAll('.product-page').forEach(initProductMedia);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); });
  } else {
    init(document);
  }
  /* Rewire interactive elements when a merchant reloads a section in Shopify's theme editor. */
  document.addEventListener('shopify:section:load', function (event) {
    event.target.querySelectorAll('[data-quote-carousel]').forEach(initQuotes);
    event.target.querySelectorAll('[data-store-carousel]').forEach(function (element) { initSimpleCarousel(element, 'store', 6000); });
    event.target.querySelectorAll('[data-education-carousel]').forEach(function (element) { initSimpleCarousel(element, 'education', 0); });
    event.target.querySelectorAll('.product-page').forEach(initProductMedia);
  });
}());
